// React
import React from 'react';

// Packages

// Utilities

import { useLabels } from 'utilities/hooks';
import { CONSTANTS } from 'utilities/configuration';

// Components
import {
    ResultReflections,
    ResultDetails,
    ResultChoice,
    ResultDataCard,
    ResultSetFieldValues,
} from '../_common';
import { ResultsPatentsDetails } from 'components/_cardContents/resultsPatents/resultsPatents';

const Name = CONSTANTS.RESULTS.PATENTS;

const Choice = props => {
    return ResultChoice({
        Name,
        methods: 'Initiative_Result__c.Patent_Status__c',
        fieldName: 'Patent_Status__c',
        ...props,
    });
};

const DataCard = ({ item, theme = 'teal', mode = [] }) => {
    return (
        <ResultDataCard
            {...{
                item,
                theme,
                methodsFieldName: 'Patent_Status__c',
                showDetails: mode.includes('details'),
            }}>
            <ResultsPatentsDetails {...{ item, theme }} />
        </ResultDataCard>
    );
};

const Details = props => {
    // ///////////////////
    // HOOKS
    // ///////////////////

    const { object } = useLabels();

    // ///////////////////
    // METHODS
    // ///////////////////

    function getItemData(formData) {
        const { Patent_Status__c, Patent_Id__c, Dates } = formData;

        // Data for sf
        return {
            Patent_Status__c,
            Patent_Id__c,
            Result_Start_Date__c: Dates?.from,
            Result_End_Date__c: Dates?.to,
        };
    }

    // ///////////////////
    // FIELDS
    // ///////////////////

    function fields() {
        return [
            {
                type: 'TextLookup',
                name: 'Patent_Id__c',
                object: object.config('Initiative_Result__c.Patent_Id__c'),
                maxLength: 200,
                config: {
                    type: 'patent',
                    async onAccept(lookup) {
                        lookup?.applicationDate &&
                            props.form.setValue(
                                'Result_Start_Date__c',
                                lookup?.applicationDate
                            );

                        lookup?.publicationDate &&
                            props.form.setValue(
                                'Result_End_Date__c',
                                lookup?.publicationDate
                            );

                        if (
                            lookup?.applicationDate ||
                            lookup?.publicationDate
                        ) {
                            props.form.setValue('Dates', {
                                from: lookup?.applicationDate,
                                to: lookup?.publicationDate,
                            });
                        }

                        props.form.trigger();
                    },
                },
            },
            {
                type: 'DateRange',
                name: 'Dates',
                object: object.config('Initiative_Result__c.Dates___Patent'),
                labelFrom: object.label(
                    'Initiative_Result__c.Result_Start_Date__c___Patent'
                ),
                labelTo: object.label(
                    'Initiative_Result__c.Result_End_Date__c___Patent'
                ),
            },
        ];
    }

    // ///////////////////
    // RETURN
    // ///////////////////

    return ResultDetails({
        fields,
        fieldSuffix: '___Patents',
        getItemData,
        ...props,
    });
};

const Reflections = props => {
    return ResultReflections({
        ...props,
    });
};

const setFieldValues = ({ choice, form, id, utilities, REPORT_ID }) => {
    // ///////////////////
    // DETAILS
    // ///////////////////

    const {
        Result_Start_Date__c,
        Result_End_Date__c,
        Patent_Status__c,
        Patent_Id__c,
    } = utilities.results.get(id);

    form.setValue('Patent_Status__c', Patent_Status__c);

    // Dates for field
    form.setValue('Dates', {
        from: Result_Start_Date__c,
        to: Result_End_Date__c,
    });

    // Dates for view only
    form.setValue('Result_Start_Date__c', Result_Start_Date__c);
    form.setValue('Result_End_Date__c', Result_End_Date__c);

    form.setValue('Patent_Id__c', Patent_Id__c);

    // ///////////////////
    // ALL THE OTHER STUFF
    // ///////////////////

    ResultSetFieldValues({
        choice,
        form,
        id,
        utilities,
        REPORT_ID,
    });
};

export { Name, DataCard, Choice, Details, Reflections, setFieldValues };
